var ajax = require('./tripletrax.ajax.js');
var utils = require('./tripletrax.utils.js');
var validator = require('./tripletrax.validator.js');
var Echo = require('laravel-echo');

function registerPushmanEvents() {

	window.Pusher = require('pusher-js');

	if ($('#locale').data().pushmanAppScheme === 'https') {
		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: $('#locale').data().pushmanPublicToken,
			wsHost: $('#locale').data().pushmanUrl,
			wsPort: $('#locale').data().pushmanPort,
			wssPort: $('#locale').data().pushmanPort,
			encrypted: true,
			enabledTransports: ['ws', 'wss']
		});
	} else {
		window.Echo = new Echo({
			broadcaster: 'pusher',
			key: $('#locale').data().pushmanPublicToken,
			wsHost: $('#locale').data().pushmanUrl,
			wsPort: $('#locale').data().pushmanPort,
			enabledTransports: ['ws', 'wss']
		});
	}

	window.Echo.channel('public').listen('MaintenanceModeAnnouncement', function (data) {
		// console.log(data);

		// Pop-Up anzeigen
		$.smallBox({
			title: trans('tripletrax.maintenance_mode'),
			content: trans('tripletrax.maintenance_mode_info', {'minutes': data['minutes']}),
			color: "#DB4A67",
			sound: $.sound_off,
			icon: "fad fa-wrench swing animated"
		});
	});

	window.Echo.private('user.' + $('#channel_name').val())
		.listen('MailIncoming', function (data) {

			//console.log(data);

			// Anzeige der ungelesenen Nachrichten bei Nachrichten (Navigation oben) aktualisieren
			if ($('#mail_nav').find('.badge').length) {
				$('#mail_nav').find('.badge').text(parseInt($('#mail_nav').find('.badge').text()) + 1);
			} else {
				$('#mail_nav').append('<span class="badge pull-right inbox-badge background-color-blue">1</span>');
			}

			// Anzeige der ungelesenen Nachrichten beim Posteingang (Navigation links) aktualisieren
			if ($('[data-folder-name="inbox"]').length) {
				if ($('[data-folder-name="inbox"]').find('strong').length) {
					$('.inbox-menu-lg').find('[data-folder-name="inbox"]').find('strong').text('(' + (parseInt($('.inbox-menu-lg').find('[data-folder-name="inbox"]').find('strong').text().replace('(', '').replace(')', '')) + 1) + ')');
				} else {
					$('.inbox-menu-lg').find('[data-folder-name="inbox"]').append('<strong>(1)</strong>');
				}
			}

			// Liste der Nachrichten aktualisieren (nur wenn gerade im Posteingang)
			if ($('.inbox-menu-lg').find('li.active').find('a').length && $('.inbox-menu-lg').find('li.active').find('a').data().folderName === 'inbox') {
				$('.inbox-menu-lg').find('[data-folder-name="inbox"]').click();
			}

			// Pop-Up anzeigen
			$.smallBox({
				title: data['user_name'],
				content: data['subject'] + '</br>' + data['message'],
				color: "#96bf48",
				sound: $.sound_off,
				icon: "fad fa-envelope swing animated",
				timeout: 4000
			});
		})
		.listen('AuditTrailLoaded', function (data) {

			if (data !== null && 'too_many_result_rows' in data && data['too_many_result_rows'] !== null && 'time_stamp' in data) {

				$.SmartMessageBox({
					title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.audit_trail_search') + "</strong></span>",
					content: Lang.get('tripletrax.too_many_audit_trail_results', { "rowCount": data['too_many_result_rows']}),
					buttons: '[' + Lang.get('tripletrax.ok') + ']'
				}, function (ButtonPressed) {

					$('#table_audit_trail').dataTable().api().clear().draw();

					$('.tt-audit-trail-results').removeClass('hide');
					$('.tt-please-wait-audit-trail').addClass('hide');

					$('#content').find('.tt-save').removeClass('disabled');
					$('#content').find('.tt-save').prop('disabled', '');

					ajax.ajaxCall('admin/audit_trail/delete/user/' + data['recipient_user_id'] + '/timestamp/' + data['time_stamp'], 'POST', '_method=DELETE', false, function (data) {
					});
				});
			} else if (data !== null && 'time_stamp' in data) {

				var userId = data['recipient_user_id'];
				var timeStamp = data['time_stamp'];

				ajax.ajaxCall('admin/audit_trail/result/user/' + userId + '/timestamp/' + timeStamp, 'GET', null, false, function (data) {
					$('#table_audit_trail').dataTable().api().clear().rows.add(data).draw();

					ajax.ajaxCall('admin/audit_trail/delete/user/' + userId + '/timestamp/' + timeStamp, 'POST', '_method=DELETE', false, function (data) {
					});
				});

				$('.tt-audit-trail-results').removeClass('hide');
				$('.tt-please-wait-audit-trail').addClass('hide');

				$('#content').find('.tt-save').removeClass('disabled');
				$('#content').find('.tt-save').prop('disabled', '');
			} else {
				$('#table_audit_trail').dataTable().api().clear().draw();

				$('.tt-audit-trail-results').removeClass('hide');
				$('.tt-please-wait-audit-trail').addClass('hide');

				$('#content').find('.tt-save').removeClass('disabled');
				$('#content').find('.tt-save').prop('disabled', '');
			}
		})
		.listen('QuestionnaireSent', function (data) {

			ajax.ajaxCall(data['route'], 'POST', {questionnaires: JSON.stringify(data['questionnaires']), language: data['languages'], signer: data['signer']}, false, function (data) {
				utils.setHtmlData($('#content'), data, true);
				utils.setIDATData($('#content'));
				$('.tt-btn-eraser,.tt-btn-query').addClass('hide');
				validator.addQuestionnairesRules($('#content').find('form'));
			});
		})
		.listen('QuestionnaireFinished', function (data) {

			var item =  $("<div></div>").html('<input type="hidden" class="idat-token" data-url="' + data['idat_url'] + '" value="' + data['token_id'] + '">' +
				'<span class="tt-pseudonym-questionnaire" data-birth-date="' + data['birth_date'] + '" data-gender="' + data['gender'] + '">' + data['pseudonym'] + '</span>');
			utils.setIDATData(item).done(function() {

				// Pop-Up anzeigen
				$.smallBox({
					title: trans('tripletrax.questionnaire_finished'),
					content: trans('tripletrax.questionnaire_finished_info', {'patient': item.find('.tt-pseudonym-questionnaire').text(), 'device': data['device']}),
					color: "#96bf48",
					sound: $.sound_off,
					icon: "fad fa-bell swing animated"
				});
			});
		});
}

module.exports.registerPushmanEvents = registerPushmanEvents;
